import {ApiEndPoint} from "../../network/api_end_point";
import {apiCaller, getToken} from "../../network/network_helper";

const apiEndPoint = new ApiEndPoint();

export const commonTaskApiCall = async (taskType,selectedTypes=[],selectedFilter='',selectedIds=[],selectedVendor=[]) => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.commonTaskUrl, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                ...(selectedTypes.length > 0 && { delivery_type: selectedTypes.join(",") }),                
                task_type: taskType,
                hub_id: localStorage.getItem('clientLocationId'),
                // hub: localStorage.getItem('clientLocationName'),
                source: apiEndPoint.source,
                ...( selectedIds.length>0&&{[selectedFilter]: selectedIds.join(",")}),
                ...(Array.isArray(selectedVendor) && selectedVendor.length > 0 && { vendor_id: selectedVendor.map((v) => v.vendorId).join(","),
            }),
            }
        })
        return response;

    } catch (e) {
        throw e;
    }
}
export const assignDriverApiCall = async (driverEmail, taskId,driverId,driverName) => {
    try {
        const token = getToken();
        const response = await apiCaller(apiEndPoint.hawkBaseUrl + apiEndPoint.assignDriver, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            params: {
                source: apiEndPoint.source
            },
            data: {
                'driver_email': driverEmail,
                'task_id': taskId,
                'driver_id': driverId,
                'driver_name': driverName,
            }
        })
        return response;

    } catch (e) {
        throw e;
    }
}